module.exports = __webpack_public_path__ + "static/media/MDO_performance.7e5f8ff3.svg";